import { authApi } from './OrmaApi';

/**
 * Login with Azure B2C credentials
 * @param {string} email 
 * @param {string} password 
 * @returns {Promise<{accessToken, idToken, refreshToken, expiresIn}>}
 */
export const loginWithB2C = async (email, password) => {
  const response = await authApi.post('/api/auth/b2c-login', {
    email,
    password
  });
  return response.data;
};

/**
 * Refresh B2C access token
 * @param {string} refreshToken 
 * @returns {Promise<{accessToken, idToken, refreshToken, expiresIn}>}
 */
export const refreshB2CToken = async (refreshToken) => {
  const response = await authApi.post('/api/auth/b2c-refresh', { refreshToken });
  return response.data;
};

/**
 * Request a password reset email for B2C user
 * @param {string} email - User's email address
 * @returns {Promise<{success: boolean, message?: string}>}
 */
export const requestB2CPasswordReset = async (email) => {
  const response = await authApi.post('api/public/request-password-reset', { email });
  return response.data;
};

/**
 * Reset B2C user password with OTP
 * @param {string} email - User's email address
 * @param {string} oneTimePassword - OTP from email
 * @param {string} newPassword - New password
 * @returns {Promise<{success: boolean, message?: string}>}
 */
export const resetB2CPassword = async (email, oneTimePassword, newPassword) => {
  const response = await authApi.post('api/public/reset-password', { email, oneTimePassword, newPassword });
  return response.data;
};